import { cn } from "@/lib/utils";

/**
 * VIB-1230: full-bredde seksjonsrad som skiller Hovedtilbud/Tilvalg/Mersalg
 * på Timetildeling — ett nivå over fase-båndene (`BudgetPhaseGroup`), så
 * skillet er tydelig uten å innføre en helt egen tabell per seksjon.
 */
export function TimetildelingSectionBand({ title }: { title: string }) {
  return (
    <tr className="border-b-2 border-foreground/70 bg-background">
      <td colSpan={6} className="px-2 pt-5 pb-1.5 first:pt-2">
        <span className="font-display font-semibold text-[13px] uppercase tracking-[0.08em] text-foreground/80">
          {title}
        </span>
      </td>
    </tr>
  );
}

/**
 * VIB-1230: rubrikk-bånd inni Tilvalg-/Mersalg-seksjonen — én per
 * option_label-gruppe eller godkjent mersalg. Ligger mellom seksjonsbåndet
 * og fase-båndene (`BudgetPhaseGroup` med `hideIndex`).
 */
export function TimetildelingRubrikkBand({ title, className }: { title: string; className?: string }) {
  return (
    <tr className={cn("border-b border-border/60", className)}>
      <td colSpan={6} className="px-2 pt-3 pb-1">
        <span className="font-display font-medium text-[13.5px] tracking-tight">{title}</span>
      </td>
    </tr>
  );
}
